import { Button, Col } from "react-bootstrap";
import Arrow from "./svg/Arrow";
import React, { useState } from "react";
import useWindowSize from "../../../hooks/useWindowSize";


const FilterButtons = ({originalDivs, action, activeId}) => {
  const { isDesktop } = useWindowSize();
  const [showAllButtons, setShowAllButtons] = useState(false);
  const toggleShowAllButtons = () => {
    setShowAllButtons(!showAllButtons);
  };
  return(
<Col xs={12} lg={10} className="mx-auto mt-4 pt-2">
  <div className="d-flex justify-content-lg-center mb-lg-4 mb-3 flex-lg-wrap overflow-auto template-button-container">
    {originalDivs
      .slice(0, isDesktop && !showAllButtons ? 8 : originalDivs.length)
      .map((div) => (
        <Button
          key={div.id}
          className={`btn btn-primary focus-0 border-0 fw-bold me-3 px-3 mb-3 d-flex align-items-center fs-7 template-button ${
            activeId === div.id ? "active" : ""
          }`}
          onClick={() => action(div.id)}
          data-title={div.title}
        >
          <svg className="icon me-2" style={{ width: 24, height: 24 }}>
            <use
              href={`/static/pages/main-page-img/template-icons.svg?v=23062025#icon-${div.title
                .toLowerCase()
                .replaceAll(" ", "")}`}
            ></use>
          </svg>
          {div.title}
        </Button>
      ))}

    {isDesktop && originalDivs.length > 8 && (
      <Button
        className="btn btn-secondary bg-white text-dark focus-0 border-0 fw-bold me-3 px-2 mb-3"
        onClick={toggleShowAllButtons}
      >
        {showAllButtons ? <Arrow deg={180} /> : <Arrow deg={0} />}
      </Button>
    )}
  </div>
</Col>
  )
}
  export default FilterButtons;
